import { render, staticRenderFns } from "./RepeaterItemAccordion.vue?vue&type=template&id=52625b4b&"
import script from "./RepeaterItemAccordion.vue?vue&type=script&lang=ts&"
export * from "./RepeaterItemAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./RepeaterItemAccordion.vue?vue&type=style&index=0&id=52625b4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports